import BackToTop from '@elem/compCommon/BackToTop';
import { createPortal } from 'react-dom';
import ProductBreifGuideSwiper from './Swiper';
import ProductBreifGuideInfo from './Info';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

/* 相关页面:
/delta-pro-ultra
/smart-home-panel
/customize-bundle-for-dpu
/customize-bundle-for-shp2
/installation-service-for-shp2
/delta-pro-ultra-daily-use
*/
export default function BriefGuide({ briefGuide, langKey, callBuy, freeQuoteBack, freeQuote, feePop = false, callFeePop = null }: any) {
    const { useState, useEffect } = useGlobal();
    const { swiper, info, popup } = briefGuide;
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <section
            className={`product-brief-guide ${css['product-brief-guide']} GtmModuleData-section`}
            data-section-id={'dpu-BriefGuide'}
            data-section-title={'dpu-BriefGuide'}
        >
            <ProductBreifGuideSwiper swiperArr={swiper} langKey={langKey} />
            <ProductBreifGuideInfo
                info={info}
                langKey={langKey}
                popup={popup}
                callBuy={callBuy}
                freeQuote={freeQuote}
                freeQuoteBack={freeQuoteBack}
                feePop={feePop}
                callFeePop={callFeePop}
            />
            {isClient && createPortal(<BackToTop />, document.body)}
        </section>
    );
}
